import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-19',
  templateUrl: './19.component.html',
  styleUrls: ['./19.component.scss'],
})
export class VbList19Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
